let accordions = document.querySelectorAll(".product-description .desc-head");
let tabsButton = document.querySelectorAll(
  ".description-heading .heading-button"
);
let tabs = document.querySelectorAll(".desc-block");
////////////////////Products deffered media toggler
document.addEventListener("DOMContentLoaded", function () {
  let toggleButtons = document.querySelectorAll(".media-toggle");

  toggleButtons.forEach(function (el, ind) {
    el.addEventListener("click", function () {
      let parent = el.closest(".product-media-container");
      let template = parent.querySelector("template");
      if (template && !parent.hasAttribute("data-loaded")) {
        parent.insertAdjacentHTML("beforeend", template.innerHTML);
        parent.setAttribute("data-loaded", "true");
      }
    });
  });

  if (toggleButtons.length > 0) {
    toggleButtons[0].click();
  }
});

////////////////////Product description toggle
accordions.forEach(function (el, ind) {
  el.addEventListener("click", function (e) {
    let parent = el.closest(".desc-block");
    parent.classList.toggle("open");
  });
});
///////////////////Tabs toggle
tabsButton.forEach(function (el, ind) {
  el.addEventListener("click", function () {
    let tabBtn = el;
    tabsButton.forEach((el,ind)=> el == tabBtn ? el.classList.add("active") : el.classList.remove("active"));
    let dataIndex = el.dataset.val;
    tabs.forEach((el, ind) => {
      if (el.dataset.id == dataIndex) {
        el.classList.add("active");
        el.classList.add("open");
      } else {
        el.classList.remove("active");
        el.classList.remove("open");
      }
    });
  });
});
